<template>
  <!-- home-type1 home-type2 ... -->
  <component :is="homeComponent" />
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectHomeType1 from '·/pages/project/home-type1'
import ProjectHomeType2 from '·/pages/project/home-type2'
import ProjectHomeType3 from '·/pages/project/home-type3'

const DEFAULT_HOME_TYPE = 1

const HOME_COMPONENTS = {
  1: ProjectHomeType1,
  2: ProjectHomeType2,
  3: ProjectHomeType3,
}

export default {
  middleware: 'auth',
  title: 'project_home_page_title',
  subtitle: 'project_home_page_subtitle',
  menuOption: '3-1',

  computed: {
    ...mapGetters({
      company: 'app/company',
      project: 'app/project',
    }),

    // Tipo de Home para esta company (campo configs de tabla companies, almacenado en la store al loguear)
    homeType() {
      const raw = this.company && this.company.configs && this.company.configs.projectHome
      const parsed = parseInt(raw, 10)
      return HOME_COMPONENTS[parsed] ? parsed : DEFAULT_HOME_TYPE
    },

    homeComponent() {
      return HOME_COMPONENTS[this.homeType]
    },
  },
};
</script>

<style scoped>
.column-scroll {
  width: 50%;
  height: calc(100vh - 150px);
  overflow-x: hidden;
  overflow-y: auto;
}
.column-scroll:not(:last-child) {
  margin-right: 0.5rem;
}
.column-scroll:last-child {
  margin-left: 0.5rem;
}
</style>
